import requestOptions from './requestOptions'
import functionsMapper from '../../models/Functions_Mapper'
import { logError } from '../../logs/ErrorLoger'
import apiValidation from '../validation/ApiRespValidation'

const getSelectsCbo = async (id, type) => {
  try {
    const options = requestOptions.options('GET', '', '')
    const resp = await fetch(global.PROVINCIA + '/' + id + '/' + type, options)
    const json = await requestOptions.handleFetchResponse(resp)
    if (json.error) return json
    const response = functionsMapper.selectMapper(json)
    return response
  } catch (error) {
    await logError(error.message, 2)
    return apiValidation.apiError500()
  }
}

const sendRequest = async (formData) => {
  try {
    const options = requestOptions.options('POST', '', formData)
    const resp = await fetch(global.SEND, options)
    const json = await requestOptions.handleFetchResponse(resp)
    if (json.error) return json
    const response = functionsMapper.responseMapper(json)
    return response
  } catch (error) {
    await logError(error.message, 2)
    return apiValidation.apiError500()
  }
}

const saveRequestTest = async (formData) => {
  try {
    const options = requestOptions.options('POST', '', formData)
    const resp = await fetch(global.SAVE_TEST_REQUEST, options)
    const json = await requestOptions.handleFetchSaveResponse(resp)
    if (json.error) return json
    const response = functionsMapper.responseMapper(json)
    return response
  } catch (error) {
    await logError(error.message, 2)
    return apiValidation.apiError500()
  }
}

const getSelectsTipoNegocio = async () => {
  try {
    const options = requestOptions.options('GET', '', '')
    const resp = await fetch(global.TIPO_NEGOCIO, options)
    const json = await requestOptions.handleFetchResponse(resp)
    if (json.error) return json
    const response = functionsMapper.selectMapper(json)
    return response
  } catch (error) {
    await logError(error.message, 2)
    return apiValidation.apiError500()
  }
}

const getSelectTier = async () => {
  try {
    const options = requestOptions.options('GET', '', '')
    const resp = await fetch(global.TIPO_TIER, options)
    const json = await requestOptions.handleFetchResponse(resp)
    if (json.error) return json
    const response = functionsMapper.selectMapper(json)
    return response
  } catch (error) {
    await logError(error.message, 2)
    return apiValidation.apiError500()
  }
}

const functionsServices = {
  sendRequest,
  getSelectsCbo,
  saveRequestTest,
  getSelectsTipoNegocio,
  getSelectTier
}

export default functionsServices
